import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'DELETE_DRAFT_FILES';

export const resetDeleteFiles = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);
  const action = useAction(() => {
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
    };
  });
  return [result, action];
};

export const useDeleteFile = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);

  const action = useAction((args) => {
    const { fileKeyList } = args;
    const eapm = window.elasticApm;
    let dtrumActionId;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_CALLED` });

      const request = {
        Objects: fileKeyList,
        Quiet: false,
      };

      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('S3_DELETE_FILE_URL')}?q=${ACTION_TYPE}`);

      fetch(config('S3_DELETE_FILE_URL'), {
        credentials: 'include',
        method: 'delete',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
      })
        .then((res) => {
          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('S3_DELETE_FILE_URL'),
              method: 'DELETE',
              userInfo: args?.userInfo,
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
            },
          });
          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('FEEDBACK_URL'),
            status: 0,
            message: 'Success',
            url: window.location.href,
            result: 'success',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
          return res.json();
        })
        .then((res) => {
          dispatch({
            type: `${ACTION_TYPE}_COMPLETED`,
            payload: res,
          });
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });

          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('S3_DELETE_FILE_URL'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
        });
    };
  });

  return [result, action];
};
